import * as React from 'react';

import { Site, Nav, Grid, List, Button } from 'tabler-react';
import AuthService from '../core/AuthService';
import { NavLink, withRouter } from 'react-router-dom';

const md5 = require('md5');

interface Props {
  children: React.ReactNode;
}

interface subNavItem {
  value: string;
  to?: string;
  icon?: string;
  LinkComponent?: React.ReactNode;
}

interface navItem {
  value: string;
  to?: string;
  icon?: string;
  active?: boolean;
  LinkComponent?: React.ReactNode;
  subItems?: Array<subNavItem>;
}

const navBarItems: Array<navItem> = [
  { value: 'Dashboard', to: '/', icon: 'home', LinkComponent: withRouter(NavLink) }, //,
  {
    value: 'Details',
    icon: 'box',
    subItems: [
      { value: 'Bank', to: '/sortCodes', LinkComponent: withRouter(NavLink) },
      { value: 'Campaigns', to: '/campaigns', LinkComponent: withRouter(NavLink) },
      { value: 'Group', to: '/groups', LinkComponent: withRouter(NavLink) },
      { value: 'Peach call log', to: '/peachPaymentCallLogs', LinkComponent: withRouter(NavLink) },
      { value: 'User', to: '/users', LinkComponent: withRouter(NavLink) },
      { value: 'User Blocked', to: '/usersblocked', LinkComponent: withRouter(NavLink) },
      { value: 'Settlement requests', to: '/transactionInAppSettlements', LinkComponent: withRouter(NavLink) },
      { value: 'Reports', to: '/reports', LinkComponent: withRouter(NavLink) }
    ]
  }
];

let accountDropdownProps = {
  avatarURL: 'https://en.gravatar.com/userimage/37190760/17210d6aefc2c2865103c87afd046242.jpeg',
  name: 'Jane Pearson',
  description: 'Administrator',
  options: [
    // { icon: "user", value: "Profile" },
    // { icon: "settings", value: "Settings" },
    // { icon: "mail", value: "Inbox", badge: "6" },
    // { icon: "send", value: "Message" },
    // { isDivider: true },
    // { icon: "help-circle", value: "Need help?" },
    { icon: 'settings', value: 'Settings', to: '/settings' },
    { icon: 'log-out', value: 'Sign out', to: '/login?logout=true' }
  ]
};

class SiteWrapper extends React.Component<Props> {
  componentDidMount() {}

  render() {
    let authService = new AuthService();
    let token = authService.currentToken();
    accountDropdownProps.name = token.name;
    accountDropdownProps.description = token.roles.join(',');
    let avatarId = md5(token.email.toLowerCase());
    accountDropdownProps.avatarURL = `https://en.gravatar.com/avatar/${avatarId}.jpeg?d=retro`;

    return (
      <Site.Wrapper
        headerProps={{
          href: '/',
          alt: 'Core Cocker',
          imageURL: '/assets/Kindashboard.svg',
          navItems: (
            <Nav.Item type="div" className="d-none d-md-flex">
              {/* <Button
                href="https://github.com/tabler/tabler-react"
                target="_blank"
                outline
                size="sm"
                RootComponent="a"
                color="primary"
              >
                Source code
              </Button> */}
            </Nav.Item>
          ),
          accountDropdown: accountDropdownProps
        }}
        navProps={{ itemsObjects: navBarItems }}
        footerProps={{
          links: [<a href="/">dashboard</a>],
          note: '',
          copyright: (
            <React.Fragment>
              Copyright © 2018
              <a href="http://tabler-react.com/"> Tabler-react</a>. Theme by
              <a href="https://codecalm.net" target="_blank" rel="noopener noreferrer">
                {' '}
                codecalm.net
              </a>{' '}
              All rights reserved.
            </React.Fragment>
          ),
          nav: (
            <React.Fragment>
              <Grid.Col auto={true}>
                <List className="list-inline list-inline-dots mb-0">
                  <List.Item className="list-inline-item">
                    <a href="./faq">FAQ</a>
                  </List.Item>
                </List>
              </Grid.Col>
              <Grid.Col auto={true}>
                <Button href="https://github.com/rolfwessels" size="sm" outline color="primary" RootComponent="a">
                  Source code
                </Button>
              </Grid.Col>
            </React.Fragment>
          )
        }}
      >
        {this.props.children}
      </Site.Wrapper>
    );
  }
}

export default SiteWrapper;
